import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Cap {
  code: string
  name: string
  countryId: string
  appliesFrom: string
  capValues: object
}

export async function getCaps(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['country_id=:countryId']
  if (search) {
    where.push(`CONCAT(name,code) ILIKE '%${search}%'`)
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN code ~ '^[0-9]+$' THEN CAST(code AS NUMERIC) ELSE NULL END), code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_caps'],
    fields: ['id', 'code', 'name', 'applies_from', 'updated_at'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getCap(id: string): Promise<Cap> {
  const data = await getData<any>({
    tables: ['pg_caps'],
    fields: [
      'id',
      'country_id as countryId',
      'code',
      'name',
      "TO_CHAR(applies_from,'yyyy-mm-dd') as appliesFrom",
      'custom_fields as custom'
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createCap(data: Cap): Promise<boolean> {
  const response: any = await http.post('calculation/caps', {
    name: data.name,
    code: data.code,
    countryId: data.countryId,
    appliesFrom: data.appliesFrom,
    capValues: data.capValues,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateCap(data: Cap, id: string): Promise<boolean> {
  const response: any = await http.put('calculation/caps/' + id, {
    name: data.name,
    code: data.code,
    countryId: data.countryId,
    appliesFrom: data.appliesFrom,
    capValues: data.capValues,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteCap(id: string): Promise<boolean> {
  const response: any = await http.delete('calculation/caps/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
